import type { ReactNode } from 'react';
import { Brand } from './Brand';
import { navigate } from '../lib/router';
import { t } from '../i18n';

/** Thin frosted global nav, Apple style: small type, quiet, always there. */
export function Header({ minimal = false, tone = 'light' }: { minimal?: boolean; tone?: 'light' | 'dark' }) {
  const dark = tone === 'dark';
  return (
    <header
      className={`sticky top-0 z-30 backdrop-blur-xl backdrop-saturate-150 ${dark ? 'bg-black/80' : 'bg-[rgb(251_251_253/0.8)]'} border-b ${dark ? 'border-white/10' : 'border-black/5'}`}
    >
      <div className="mx-auto flex h-12 max-w-[1024px] items-center justify-between px-5">
        <Brand tone={dark ? 'white' : 'ink'} />
        {!minimal && (
          <nav className={`flex items-center gap-5 text-[13px] ${dark ? 'text-white/80' : 'text-ink/80'}`}>
            <a href="/#how" className="hidden hover:opacity-100 sm:inline">
              {t('nav.how')}
            </a>
            <button type="button" onClick={() => navigate('/helper')} className="whitespace-nowrap hover:opacity-100">
              {t('nav.helper')}
            </button>
            <a href="/#demo" className="hidden rounded-full bg-blue px-3 py-1 text-white hover:bg-blue-700 sm:inline">
              {t('nav.demo')}
            </a>
          </nav>
        )}
      </div>
    </header>
  );
}

export function Footer() {
  return (
    <footer className="bg-surface text-xs text-muted">
      <div className="mx-auto max-w-[1024px] px-5 py-6">
        <p className="border-b border-line pb-4">{t('footer.note')}</p>
        <div className="flex flex-col gap-2 pt-4 sm:flex-row sm:items-center sm:justify-between">
          <span>{t('footer.line')}</span>
          <span>{t('app.poc')}</span>
        </div>
      </div>
    </footer>
  );
}

/** Narrow single-column page used by the finder, code entry and helper card. */
export function Page({ children, minimalHeader = false }: { children: ReactNode; minimalHeader?: boolean }) {
  return (
    <div className="flex min-h-dvh flex-col bg-surface">
      <Header minimal={minimalHeader} />
      <main className="mx-auto w-full max-w-[560px] flex-1 px-5 pb-16 pt-10">{children}</main>
      <Footer />
    </div>
  );
}
